// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { buttonTransparent } from "@stanion/XDL/PreStyle/button";
import { xBaseTheme } from "@stanion/XDL/types";
import { color, xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

const MODAL_DESKTOP_PADDING = 25;
const MODAL_MOBILE_PADDING = 20;

export default {
    sizeVariants: { small: 500, medium: 800, large: 1110 },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            modalContent: css`
                &&& {
                    padding: ${MODAL_DESKTOP_PADDING / 2}px ${MODAL_DESKTOP_PADDING}px ${MODAL_DESKTOP_PADDING}px;
                    ${xScreen("lte", "xs")} {
                        padding-left: ${MODAL_MOBILE_PADDING}px;
                        padding-right: ${MODAL_MOBILE_PADDING}px;
                    }
                }
                button {
                    &&& {
                        display: inline-block;
                    }
                }
            `,
            modalBody: css`
                ${xScreen("lte", "md")} {
                    height: auto;
                    max-height: calc(100% - 35px);
                    max-width: 90%;
                    margin: 18px;
                }
            `,
        },
        closeButtonIconProps: {
            size: 20,
            css: css`
                svg {
                    color: ${color("common.ui8")};
                }
            `,
        },
        closeButtonProps: {
            size: 36,
            css: css`
                ${buttonTransparent}
                padding: 0;
            `,
        },
    },
} as xBaseTheme["modal"];
